import React from "react";
import { Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import CV from "./pages/CV";
import Project1 from "./pages/Project1";
import Project2 from "./pages/Project2";
import Project3 from "./pages/Project3";
import Project4 from "./pages/Project4";
import Project5 from "./pages/Project5";

const App = () => {
  console.log("App component rendering");
  return (
    <div>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/resume" element={<CV />} />
        <Route path="/project1" element={[<Project1 />]} />
        <Route path="/project2" element={[<Project2 />]} />
        <Route path="/project3" element={[<Project3 />]} />
        <Route path="/project4" element={[<Project4 />]} />
        <Route path="/project5" element={[<Project5 />]} />
      </Routes>
    </div>
  );
};

export default App;
